module.exports = __webpack_public_path__ + "media/soundtrack.cd485a4c.mp3";